const menu = [
  {
    key: 'overview',
    label: 'Overview',
    translationKey: 'app.navigation.main.overview',
    to: '/',
    exact: true,
  },
  {
    key: 'auditlog',
    label: 'Audit log',
    translationKey: 'app.navigation.main.auditLog',
    to: '/audit-log',
    exact: false,
  },
  {
    key: 'users',
    label: 'Users',
    translationKey: 'app.navigation.main.users',
    to: '/users',
    exact: false,
  },
  {
    key: 'externalAccess',
    label: 'External Access',
    translationKey: 'app.navigation.main.externalAccess',
    to: '/external-access',
    exact: false,
  },
  {
    key: 'rbac',
    label: 'Rbac',
    translationKey: 'app.navigation.main.rbac',
    to: '/rbac',
    exact: false,
  },
  {
    key: 'oauth',
    label: 'Oauth clients',
    translationKey: 'app.navigation.main.oauthClients',
    to: '/oauth-clients',
    exact: false,
  },
  {
    key: 'channels',
    label: 'Channels',
    translationKey: 'app.navigation.main.channels',
    to: '/channels',
    exact: false,
  },
  {
    key: 'appStore',
    label: 'App store',
    translationKey: 'app.navigation.main.appStore',
    to: '/store',
    exact: false,
  },
  {
    key: 'integrations',
    label: 'Integrations',
    translationKey: 'app.navigation.main.integrations',
    to: '/integrations',
    exact: false,
  },
  {
    key: 'contract',
    label: 'Contract',
    translationKey: 'app.navigation.main.contract',
    to: '/contract',
    exact: false,
  },
  {
    key: 'profile',
    label: 'My profile',
    translationKey: 'app.navigation.main.profile',
    to: '/profile',
    exact: false,
  },
  {
    key: 'settings',
    label: 'Settings',
    translationKey: 'app.navigation.main.settings',
    to: '/settings',
    exact: false,
  },
];

export default menu;
